import * as React from "react";
import { SVGProps } from "react";
const CopyIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={12}
    height={14}
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <g id="Group">
      <path
        id="Vector"
        d="M8.66669 1L0.666687 1L0.666687 9.66667"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M3.33337 3.66675L11.3334 3.66675V11.6667C11.3334 12.0204 11.1929 12.3595 10.9428 12.6096C10.6928 12.8596 10.3537 13.0001 10 13.0001H4.66671C4.31309 13.0001 3.97395 12.8596 3.7239 12.6096C3.47385 12.3595 3.33337 12.0204 3.33337 11.6667V3.66675Z"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
export default CopyIcon;
